import type { ServiceCall } from '../types'

/** `domain.service` combinations that demand a deliberate hold-to-confirm. */
const SENSITIVE = new Set<string>([
  'lock.unlock',
  'lock.lock',
  'alarm_control_panel.alarm_arm_away',
  'alarm_control_panel.alarm_arm_home',
  'alarm_control_panel.alarm_arm_night',
  'alarm_control_panel.alarm_disarm',
  'cover.open_cover', // Tesla charge port / frunk / trunk
  'update.install',
])

/** entity_ids that are always sensitive regardless of the service. */
const SENSITIVE_ENTITIES = new Set<string>([
  'script.zaptec_stop_charging',
  'script.tesla_stop_charging',
])

export function isSensitive(call: ServiceCall): boolean {
  if (SENSITIVE.has(`${call.domain}.${call.service}`)) return true
  const target = call.target?.entity_id
  const ids = Array.isArray(target) ? target : target ? [target] : []
  return ids.some((id) => SENSITIVE_ENTITIES.has(id))
}

/**
 * Trailing-debounce window (ms) for a service, keyed by `domain.service`.
 * Latest value wins; optimistic state still updates on every tick so the UI
 * stays live. 0 = fire immediately.
 */
const DEBOUNCE: Record<string, number> = {
  'light.turn_on': 250,
  'media_player.volume_set': 200,
  'number.set_value': 300,
  'input_number.set_value': 300,
  'climate.set_temperature': 600,
  'cover.set_cover_position': 300,
}

export function debounceMs(call: ServiceCall): number {
  return DEBOUNCE[`${call.domain}.${call.service}`] ?? 0
}
